import React, {FC, useState} from 'react'
import './ProductItem.scss'
import Button from '../Button/Button'
import Arrow from '../Arrow/Arrow'
import {IProduct} from "../../types/types";

interface IProductItem {
    product: IProduct
    className: string
}

const ProductItem: FC<IProductItem> = ({product, className}) => {
    const [selectedImage, setSelectedImage] = useState<number>(1)
    const totalImages = product.images.length

    const handlerBack = () => {
        setSelectedImage(prevState => prevState - 1)
    }
    const handlerForward = () => {
        setSelectedImage(prevState => prevState + 1)

    }
    const srcImage = product.images.find(i => i.id === selectedImage)?.src

    return (
        <div className={'product' + className}>
                <div className='product__image'>
                    {selectedImage > 1 &&
                        <Arrow cb={handlerBack} direction="back"/>
                    }
                    <img src={srcImage} alt='image'/>
                    {selectedImage < totalImages &&
                        <Arrow cb={handlerForward} direction="forward"/>
                    }
                </div>
        </div>
    )
}

export default ProductItem